import {constantsTypes} from '../reduxConstants';

export const setBankofferViewMode = (value)=>{
    return{
        type:constantsTypes.BANK_OFFER_ID,
        payload:value
    }
}